// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../cache/REACT_API_PROD/nc_react_ui_node_modules_cache/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../cache/REACT_API_PROD/nc_react_ui_node_modules_cache/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nc-roam-subscription-page-logo {
  height: 50px;
  width: 300px;
  background-position: center center;
  background-size: contain;
  background-repeat: no-repeat;
  margin-bottom: 1em;
}
`, "",{"version":3,"sources":["webpack://./src/components/nc-roam-subscription/styles.less"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,YAAA;EACA,kCAAA;EACA,wBAAA;EACA,4BAAA;EACA,kBAAA;AACF","sourcesContent":[".nc-roam-subscription-page-logo {\n  height: 50px;\n  width: 300px;\n  background-position: center center;\n  background-size: contain;\n  background-repeat: no-repeat;\n  margin-bottom: 1em;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
